module.exports = __webpack_public_path__ + "img/maskenaffaere.64f09a7c.png";